export const MALE = "Male";
export const FEMALE = "Female";
export const UNISEX = "Unisex";
export const CHILDREN = "children";
export const KIDS = "Kids";
export const MEN = "mens";
export const WOMEN = "womens";
export const adultGROUP = "adults";
export const maleGROUP = "men";
export const femaleGROUP = "women";
